<template>
 <div>
   <div class="loading" v-if="loading">
   
<div class="loader">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
    </div>
  <div v-if="fetch"> 
<section class=" section" style="padding-top:30px;">
	<!-- Container Start -->
	<div class="container">
		<div class="row">
			<div class="col-12">
				<!-- Section title -->
				
				<h2 class="ltext-105 pb-4 txt-center">
					All Categories
				</h2>
				<!-- <div class="row">
					
					<div class="col-lg-3 offset-lg-0 col-md-5 offset-md-1 col-sm-6" 
					v-for="(hh, cat) in categoryList" :key="cat">
						<div class="category-block">
							<div class="header">
								<i class="fa fa-tag icon-bg-1"></i> 
								<h4><router-link  :to="{name: 'storeproducts', query: {cat: cat}}">{{cat}}</router-link></h4>
							</div>
							<ul class="category-list" >
								<li  v-for="(category, i) in hh" :key="i"><a>{{category}}</a></li>
							
							</ul>
						</div>
					</div> -->
						<div class="row">
					
					<div class="col-lg-3 offset-lg-0 col-md-4 offset-md-1 col-sm-6" 
					v-for="(values, key) in shopcats" :key="key" style="height:auto;">
						<div class="category-block" style="background-color: #fff;">
							<div class="header">
								<i class="fa fa-tag icon-bg-1"></i> 
								<h4><a>{{key}}</a></h4>
							</div>
							<ul class="category-list" >
								<li  v-for="(value, key) in values" :key="key" v-if="value > 0"><router-link  :to="{name: 'storeproducts', params: {cat: key}}">{{key}}<span>{{value}}</span></router-link></li>
							
							</ul>
						</div>
					</div>
					
				</div>
			</div>
		</div>
	</div>
	<!-- Container End -->
</section>
  </div>
 </div>
</template>

<script>
import db from "../../config/FirebaseInit"
import firebase from 'firebase/app';
import mobiles from '../../data/mobiles'
import ClothingAccessories from '../../data/ClothingAccessories'
import fashi from '../../data/fashi'
export default {
  name: 'categories',
  data() {
	  return {
		   loading: false,
          fetch: false,
		 currentPage4: 4,
		products: [],
		visible: 'block',
		visible1: 'none',
		category: this.$route.query.cat,

		 display: "none",
		 suggestion: 'none',
		  openedItems: {},
		  categoriesList: [],
		  subcategories:this.$route.query.cat,
		  subcat: [],
		  shops: [],
			categoryList: [],
			shopcats:{},
		 
		  search: '',
		lastVisible: '',
		items:25,
		dismore:'',
		maxitems: 100000 
	  }
  },

	watch: {
		subcategories() {
		  
		  //console.log(this.subcategories + "subct")
		   if(this.shops[0].shoptype == 'Fashion'){
			//console.log(this.$route.query.cat + "shop")
			
		  this.categoriesList = ClothingAccessories[ this.subcategories]
		  
		  //console.log( "rtggg")
    //   for( i in this.categoriesList){
				  
	// 			    //console.log(this.categoriesList[i])
	// 		   }
	// 	  //console.log(this.categoriesList)
	// 	  //console.log(this.shops)
      }
      if(this.shops[0].shoptype == 'Elec'){
          this.categoriesList = mobiles
      }

	  },
	  shops () {
		   //console.log(this.subcategories + "subct")
		   if(this.shops[0].shoptype == 'Fashion'){
			//console.log(this.$route.query.cat + "shop")
			this.categoryList = ClothingAccessories
		  this.categoriesList = ClothingAccessories[ this.subcategories]
		  
		  //console.log( "rtggg")
    //   for( i in this.categoriesList){
				  
	// 			    //console.log(this.categoriesList[i])
	// 		   }
	// 	  //console.log(this.categoriesList)
	// 	  //console.log(this.shops)
      }
      if(this.shops[0].shoptype == 'Elec'){
          this.categoriesList = mobiles
      }
        
	  },
	},
	
	beforeCreate(){
	
	},
	methods:{
		 backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    },
	},
  created () {
	  this.backToTop()
	  this.loading = true
      this.fetch = false
	    this.$store.state.secondaryDatabase.collection('shops').where('owner', '==', this.$route.params.storename)
		.onSnapshot(querySnapshot => {
        this.shops = []
      querySnapshot.forEach(doc => {
        const data = {
			'id' : doc.id,
		  'shoptype' : doc.data().shoptype,
		  'categories': doc.data().categories
          
        }
		this.shops.push(data)
		this.shopcats = this.shops[0].categories
		  //console.log(this.shops[0])
		   this.loading = false
      		this.fetch = true
      })
	 })
	// .then( () => {
// 		  db.collection('shops').doc('eFN01P0oQmpoeIRmyhP3').update(
// 			 {
// 				 categories: {
    
// "Men’s Clothing": {
//     "T-Shirts":0,
//     "Shirts":0,
//     "Blazers":0,
// 	"Sweaters ":0,
// 	"Jeans":0,
// 	"Pants":0,
// 	"Shorts":0,
// 	"Coats & Jackets":0,
// 	"Suits":0,
// 	"Athletic Apparel":0,
// 	"Socks":0,
// 	"Underwear":0,
// 	"Shoes":0

// },
    

// "Women’s Clothing": {
//     "Dresses":0,
//     "Tops & Blouses":0,
// 	"T- Shirts":0,
// 	"Sweaters":0,
// 	"Coats & Jackets":0,
// 	"Jeans":0,
// 	"Pants":0,
// 	"Shorts":0,
// 	"Skirts":0,
// 	"Swimwear":0,
// 	"Intimates & Sleepwear":0 

// },


// "Kids & Baby": {
// 	"Girls (newborn - 5T)":0,
// 	"Girls (4 and Up)" :0,
// 	"Boys (newborn -5T)":0,
// 	"Boys (4 and Up)":0


// },

// "Men’s Accessories":{
// 	"Sunglasses":0,
// 	"Wallets":0,
// 	"Scarves & Wraps":0,
// 	"Watches":0,
// 	"Belts":0,
// 	"Hats":0,
// 	"Caps":0,
// 	"Gloves & Mittens":0,		

// },

// "Women’s Accessories":{
// 	"Sunglasses":0,
// 	"Wallets":0,
// 	"Scarves & Wraps":0,
// 	"Watches":0,
// 	"Belts":0,
// 	"Hats":0,
// 	"Caps":0,
// 	"Gloves & Mittens":0,	

// },


// }

// 			 }
// 		 )
// 		  .then(doc => {
//           //console.log('doc is', doc)
// 	  })
//	 })
  
  
	  
}

}
</script>
<style scoped>
@import url('~@/assets/main/css/loading.css');
@media (max-width: 767px){
	  h2 {
		  font-size: 30px;
		  padding-top: 4.2rem !important;
	  }
  }
</style>



// WEBPACK FOOTER //
// src/components/store/Categories.vue